import Card from "@/components/UI/Card/Card";
import styles from "./StepCard.module.css";

interface StepCardProps {
  title: string;
  description?: string;
  className?: string;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export default function StepCard({
  title,
  description,
  className,
  onClick,
  isLoading,
  disabled,
}: StepCardProps) {
  return (
    <Card
      className={`${styles.stepCard} ${className || ""}`.trim()}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      <span className={styles.titleRow}>
        <span className={styles.title}>{title}</span>
        {isLoading && <span className={styles.loader} />}
      </span>
      {description && <span className={styles.description}>{description}</span>}
    </Card>
  );
}
